import { spaceCadet } from '@cogneed/react-utils';
import {
  Box, BoxProps, styled,
} from '@mui/material';
import { scrollbarStyle1 } from '../../../styles/scrollbarStyles';

const StyledBox = styled((props: BoxProps) => {
  const { children, ...other } = props;
  return (
    <Box {...other}>
      <Box>{children}</Box>
    </Box>
  );
})(() => ({
  height: '100%',

  '& > .MuiBox-root': {
    backgroundColor: spaceCadet[100],
    minWidth: 200,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    alignItems: 'stretch',
    height: '100%',

    '& > .MuiBox-root.content': {
      backgroundColor: 'white',
      flexGrow: 1,
      padding: '12px 8px',
      margin: '0px 8px 12px 8px',
      borderRadius: 4,
      overflow: 'auto',
    },
  },

  ...scrollbarStyle1,
}));

export default StyledBox;
